var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMessageChatSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15L6.92474 18.1137C6.49579 18.548 6.28131 18.7652 6.09695 18.7805C5.93701 18.7938 5.78042 18.7295 5.67596 18.6076C5.55556 18.4672 5.55556 18.162 5.55556 17.5515V15.9916C5.55556 15.444 5.10707 15.0477 4.5652 14.9683V14.9683C3.25374 14.7762 2.22378 13.7463 2.03168 12.4348C2 12.2186 2 11.9605 2 11.4444V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H14.2C15.8802 2 16.7202 2 17.362 2.32698C17.9265 2.6146 18.3854 3.07354 18.673 3.63803C19 4.27976 19 5.11984 19 6.8V11",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14.2C22 13.0799 22 12.5198 21.782 12.092C21.5903 11.7157 21.2843 11.4097 20.908 11.218C20.4802 11 19.9201 11 18.8 11H13.2C12.0799 11 11.5198 11 11.092 11.218C10.7157 11.4097 10.4097 11.7157 10.218 12.092C10 12.5198 10 13.0799 10 14.2V16.7143C10 17.8344 10 18.3944 10.218 18.8223C10.4097 19.1986 10.7157 19.5046 11.092 19.6963C11.5198 19.9143 12.0799 19.9143 13.2 19.9143H14.9969C15.3695 19.9143 15.5558 19.9143 15.7356 19.9474C15.8951 19.9768 16.0504 20.0255 16.1982 20.0924C16.3647 20.1678 16.5177 20.2742 16.8236 20.4869L19 22V19.9143C19.9319 19.9143 20.3978 19.9143 20.7654 19.762C21.2554 19.5591 21.6448 19.1697 21.8478 18.6797C22 18.3121 22 17.8462 22 16.9143V14.2Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessageChatSquare);
export default __webpack_public_path__ + "static/media/IconMessageChatSquare.e714b9d59f58304aefdbc71f5df62992.svg";
export { ForwardRef as ReactComponent };